import MappingDataAPI from "../services/MappingDataAPI";
import { UserStatsResponse } from "../model/UserStatsResponse";
import * as label from '../../shared/util/label'
import { fomratWithCommasAndDecimals } from "../../shared/util/currencyUtils";
import { UserStatsData } from "../model/UserStatsData";

const transactionList = [
    'arr', 'bnb', 'bnd', 'bpc', 'brw', 'nbq', 'nbs', 'nra', 'pab',
    'pch', 'pcq', 'pnq', 'pol', 'rei', 'rew', 'rix', 'rnr', 'rrq',
    'rwl', 'rwq', 'rwr', 'rwx', 'syn', 'syr', 'xlc', 'xln', 'del'
] as const;

const showTransactionList = (data: any[] | undefined | null): string[] => {
    if (!Array.isArray(data) || data.length === 0) return [];
    return transactionList.filter(key => data.some(row => Number(row?.[key]) !== 0));
};

class StatisticsDataService {
    mappingDataAPI: MappingDataAPI = new MappingDataAPI();    

    getStatsGridColumns = async (fromDate: string, toDate: string) => {
        var statsData = await this.mappingDataAPI.getStatistics(fromDate, toDate);
        let stats = [];
        if (statsData != null && statsData.length > 0) {
            stats = statsData.map((item: UserStatsResponse) =>
            ({
                carriers: item.carriers,
                totalTransactionCount: item.totalTransactionCount,
                totalAppliedAutomaticallyCount: item.totalAppliedAutomaticallyCount,
                remainingCount: item.remainingCount,
                totalPremium: item.totalPremium,
                averagePremium: item.averagePremium,
                totalError: item.totalError,
                totalHold: item.totalHold,
                arr: item.arr,
                bnb: item.bnb,
                bnd: item.bnd,
                bpc: item.bpc,
                brw: item.brw,
                nbq: item.nbq,
                nbs: item.nbs,
                nra: item.nra,
                pab: item.pab,
                pch: item.pch,
                pcq: item.pcq,
                pnq: item.pnq,
                pol: item.pol,
                rei: item.rei,
                rew: item.rew,
                rix: item.rix,
                rnr: item.rnr,
                rrq: item.rrq,
                rwl: item.rwl,
                rwq: item.rwq,
                rwr: item.rwr,
                rwx: item.rwx,
                syn: item.syn,
                syr: item.syr,
                xlc: item.xlc,
                xln: item.xln,
                del: item.del,
            }));
        }
        const visibletransactionList = showTransactionList(stats);
        const columns = this.getGridColumns(visibletransactionList);

        return { stats, columns };
    }

    public getGridColumns(visibletransactionList: string[] = []) {
        const baseColumns = [
            {
                Header: label.Statistics.Carriers,
                accessor: 'carriers',
                Cell: row => {
                    return (
                        <div className='todoList-grd-cell stats-carrier-cell'>
                            <span className='stats-carrier-name' title={row.row?.original?.carriers}>{row.row?.original?.carriers}</span>
                        </div>
                    )
                },
                width: 220
            },
            {
                Header: label.Statistics.Total_Transaction_Count,
                accessor: 'totalTransactionCount',
                Cell: row => {
                    return (
                        <div className='todoList-grd-cell stats-cell'>
                            <span className='stats-cell-content' title={row.row?.original?.totalTransactionCount}>{row.row?.original?.totalTransactionCount}</span>
                        </div>
                    )
                },
                width: 190
            },
            {
                Header: label.Statistics.Total_Applied_Automatically_Count,
                accessor: 'totalAppliedAutomaticallyCount',
                Cell: row => {
                    return (
                        <div className='todoList-grd-cell stats-cell'>
                            <span className='stats-cell-content' title={row.row?.original?.totalAppliedAutomaticallyCount}>{row.row?.original?.totalAppliedAutomaticallyCount}</span>
                        </div>
                    )
                },
                width: 260
            },
            {
                Header: label.Statistics.Remaining_Count,
                accessor: 'remainingCount',
                Cell: row => {
                    return (
                        <div className='todoList-grd-cell stats-cell'>
                            <span className='stats-cell-content' title={row.row?.original?.remainingCount}>{row.row?.original?.remainingCount}</span>
                        </div>
                    )
                },
                width: 140
            },
            {
                Header: label.Statistics.Total_Premium,
                accessor: 'totalPremium',
                Cell: row => {
                    return (
                        <div className='todoList-grd-cell stats-cell'>
                            <span className='stats-cell-content' title={fomratWithCommasAndDecimals(row.row?.original?.totalPremium)}>{fomratWithCommasAndDecimals(row.row?.original?.totalPremium)}</span>
                        </div>
                    )
                },
                width: 150
            },
            {
                Header: label.Statistics.Average_Premium,
                accessor: 'averagePremium',
                Cell: row => {
                    return (
                        <div className='todoList-grd-cell stats-cell'>
                            <span className='stats-cell-content' title={fomratWithCommasAndDecimals(row.row?.original?.averagePremium)}>{fomratWithCommasAndDecimals(row.row?.original?.averagePremium)}</span>
                        </div>
                    )
                },
                width: 150
            },
            {
                Header: label.Statistics.Total_Error,
                accessor: 'totalError',
                Cell: row => {
                    return (
                        <div className='todoList-grd-cell stats-cell'>
                            <span className='stats-cell-content' title={row.row?.original?.totalError}>{row.row?.original?.totalError}</span>
                        </div>
                    )
                },
                width: 100
            },
            {
                Header: label.Statistics.Total_Hold,
                accessor: 'totalHold',
                Cell: row => {
                    return (
                        <div className='todoList-grd-cell stats-cell'>
                            <span className='stats-cell-content' title={row.row?.original?.totalHold}>
                                {row.row?.original?.totalHold}
                            </span>
                        </div>
                    )
                },
                width: 100
            }
        ];
        const dynamicColumns = (visibletransactionList ?? []).map(key => ({
            Header: key.toUpperCase(),
            accessor: key,
            Cell: row => {
                return (
                    <div className='todoList-grd-cell stats-cell'>
                        <span className='stats-cell-content' title={row.row?.original?.[key]}>{row.row?.original?.[key]}</span>
                    </div>
                )
            },
            width: 80
        }));

        return [...baseColumns, ...dynamicColumns];
    }
    
    loadUserStats = async (fromDate?: Date | string, toDate?: Date | string): Promise<{ stats: UserStatsData[], headerLabels: Record<string, string> }> => {
        const response = await this.mappingDataAPI.getUserStatistics(fromDate, toDate);

        const stats: UserStatsData[] =
            response.data.map(item => ({
                users: item.user,
                date1Count: item.counts?.date1Count ?? 0,
                date2Count: item.counts?.date2Count ?? 0,
                date3Count: item.counts?.date3Count ?? 0,
                date4Count: item.counts?.date4Count ?? 0,
                date5Count: item.counts?.date5Count ?? 0,
                filterDateCount: item.counts?.filterDateCount ?? 0
            }));

        return {
            stats,
            headerLabels: response.headerLabels
        };
    }
    
    public userGridColumns = (headerLabels?: Record<string, string>) => {

        const h = headerLabels ?? {};
        return [
            {
                Header: label.Statistics.USER,
                accessor: 'users',
                Cell: row => {
                    return (
                        <div className='todoList-grd-cell'>
                            <span title={row.row?.original?.users}>{row.row?.original?.users}</span>
                        </div>
                    )
                },
                width: 220
            },
            {
                Header: h.date1Header,
                accessor: 'date1Count',
                Cell: row => {
                    return (
                        <div className='todoList-grd-cell'>
                            <span title={row.row?.original?.date1Count}>{row.row?.original?.date1Count}</span>
                        </div>
                    )
                },
                width: 130
            },
            {
                Header: h.date2Header,
                accessor: 'date2Count',
                Cell: row => {
                    return (
                        <div className='todoList-grd-cell'>
                            <span title={row.row?.original?.date2Count}>{row.row?.original?.date2Count}</span>
                        </div>
                    )
                },
                width: 130
            },
            {
                Header: h.date3Header,
                accessor: 'date3Count',
                Cell: row => {
                    return (
                        <div className='todoList-grd-cell'>
                            <span title={row.row?.original?.date3Count}>{row.row?.original?.date3Count}</span>
                        </div>
                    )
                },
                width: 130
            },
            {
                Header: h.date4Header,
                accessor: 'date4Count',
                Cell: row => {
                    return (
                        <div className='todoList-grd-cell'>
                            <span title={row.row?.original?.date4Count}>{row.row?.original?.date4Count}</span>
                        </div>
                    )
                },
                width: 130
            },
            {
                Header: h.date5Header,
                accessor: 'date5Count',
                Cell: row => {
                    return (
                        <div className='todoList-grd-cell'>
                            <span title={row.row?.original?.date5Count}>{row.row?.original?.date5Count}</span>
                        </div>
                    )
                },
                width: 130
            },
            {
                Header: label.Statistics.As_Per_Dates,
                accessor: 'filterDateCount',
                Cell: row => {
                    return (
                        <div className='todoList-grd-cell'>
                            <span title={row.row?.original?.filterDateCount}>{row.row?.original?.filterDateCount}</span>
                        </div>
                    )
                },
                width: 130
            }
        ]
    }
}

export default StatisticsDataService;